export const STATUS_TYPE = {
  DEFAULT: "default",
  WALK: "walk",
  SLEEP: "sleep",
  CLIMB: "climb",
  EAT: "eat",
  CLICK: "click",
  MOVE: "move",
  PENDING: "pending",
} as const;

export type STATUS_TYPE_KEY = keyof typeof STATUS_TYPE;

export type STATUS_TYPE_VALUE = typeof STATUS_TYPE[STATUS_TYPE_KEY];

export const STATUS_TYPE_MAP = {
  [STATUS_TYPE.DEFAULT]: "기본",
  [STATUS_TYPE.WALK]: "걷기",
  [STATUS_TYPE.SLEEP]: "꾸벅꾸벅",
  [STATUS_TYPE.MOVE]: "이동시",
  [STATUS_TYPE.CLICK]: "클릭 시",
  [STATUS_TYPE.EAT]: "냠냠",
  // [STATUS_TYPE.CLIMB]: "벽타기",
  // [STATUS_TYPE.PENDING]: "대기",
};

export const STATUS_RANDOM_TYPE_MAP = {
  [STATUS_TYPE.DEFAULT]: "기본",
  [STATUS_TYPE.WALK]: "걷기",
  [STATUS_TYPE.SLEEP]: "꾸벅꾸벅",
  [STATUS_TYPE.EAT]: "냠냠",
};

export const statusList = Object.keys(STATUS_TYPE_MAP).map((key) => {
  // 모든 상태
  return {
    key: key,
    value: STATUS_TYPE_MAP[key],
  };
});

export const statusRandomList: any[] = Object.keys(STATUS_RANDOM_TYPE_MAP).map(
  (key) => {
    // 랜덤시간동안 발생가능한 상태
    return {
      key: key,
      value: STATUS_RANDOM_TYPE_MAP[key],
    };
  }
);
